import axios from 'axios';

class UserApiClass {
  async getAll() {
    const jobs = await axios.get('/api/users/');
    return jobs.data;
  }

  async get(id: number) {
    const jobs = await axios.get('/api/users/' + id);
    return jobs.data;
  }

  async getAllRoles() {
    const jobs = await axios.get('/api/users/roles');
    return jobs.data;
  }

  async save(user: any) {
    await axios.post('/api/users/', user);
  }

  async deleteById(id: number) {
    await axios.delete('/api/users/' + id);
  }

  async resetPassword(id: number) {
    await axios.put('/api/users/reset/' + id);
  }
}

export const UserApi = new UserApiClass();
